import client from '../httpClient';

const simulatorGetJISCodeApi = (areaCode) => {
  return client.get(`/simulator/cities/${areaCode}`);
};

export default simulatorGetJISCodeApi;
